import { render } from "./hero.vue?vue&type=template&id=c3612f7c&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=c3612f7c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c3612f7c"

export default script